/** Build submit payload answers for professional public take. */

export function buildProfAnswerEntry({
    value = "",
    optionIndex = null,
    optionIndexes = null,
    customAnswer = "",
    violations = [],
    forcedIncorrect = false,
    durationSeconds = 0,
} = {}) {
    const uniqueViolations = [...new Set((violations || []).filter(Boolean))];
    const normalizedIndexes = Array.isArray(optionIndexes)
        ? [...new Set(optionIndexes.map(Number).filter(Number.isFinite))]
        : optionIndex == null ? [] : [Number(optionIndex)];
    return {
        value: value != null ? String(value) : "",
        option_index: optionIndex == null ? null : Number(optionIndex),
        option_indexes: normalizedIndexes,
        custom_answer: customAnswer != null ? String(customAnswer) : "",
        duration_seconds: Math.max(0, Math.floor(Number(durationSeconds) || 0)),
        violations: uniqueViolations,
        forced_incorrect: Boolean(forcedIncorrect || uniqueViolations.length),
    };
}

export function answersForSubmit(answersById, questions) {
    const out = {};
    (questions || []).forEach((q) => {
        const key = String(q.id);
        const entry = answersById[key];
        if (!entry) return;
        const hasValue = String(entry.value || "").trim()
            || String(entry.custom_answer || "").trim()
            || entry.option_index != null
            || (entry.option_indexes || []).length;
        const forced = Boolean(entry.forced_incorrect || (entry.violations || []).length);
        if (!hasValue && !forced) return;
        out[key] = buildProfAnswerEntry({
            value: entry.value,
            optionIndex: entry.option_index,
            optionIndexes: entry.option_indexes,
            customAnswer: entry.custom_answer,
            violations: entry.violations,
            forcedIncorrect: forced,
            durationSeconds: entry.duration_seconds,
        });
    });
    return out;
}

/** On timeout — ensure every unanswered question is marked forced incorrect. */
export function fillUnansweredAsTimedOut(answersById, questions) {
    const next = { ...answersById };
    (questions || []).forEach((q) => {
        const key = String(q.id);
        const prev = next[key];
        if (prev && (String(prev.value || "").trim() || String(prev.custom_answer || "").trim() || prev.option_index != null || (prev.option_indexes || []).length || prev.forced_incorrect)) {
            return;
        }
        next[key] = buildProfAnswerEntry({
            value: prev?.value || "",
            optionIndex: prev?.option_index ?? null,
            optionIndexes: prev?.option_indexes,
            customAnswer: prev?.custom_answer,
            violations: prev?.violations || [],
            forcedIncorrect: true,
            durationSeconds: prev?.duration_seconds,
        });
    });
    return next;
}
